import React from 'react';
import { useRecoilValue } from 'recoil';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { Param } from '../RoomParam';

export const AreaUser: React.FC = () => {
  const dimensions = useRecoilValue(dimensionsAtom);
  const {
    inputParameters: { areaUser },
  } = dimensions;

  if (areaUser) {
    return <Param label="Площадь помещения" value={`${areaUser} м²`} />;
  }

  return null;
};
